import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("tokenId");

    if (!token) {
        return <Navigate to="/" />;
    }
    return children;
};

export default ProtectedRoute;
